import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';
import InformationCard from '../../InformationCard';
import CurrencyWrapper from '../../../common/CurrencyWrapper';
import { ReactComponent as MoneyIcon } from '../../../../assets/img/icons/money-minimalist.svg';
import { ReactComponent as CalenderIcon } from '../../../../assets/img/icons/calender.svg';

export default function HotelReservationInformation({ order, reservations }) {
  const { messages } = useIntl();

  const { dailyValue, anticipation } = useMemo(() => {
    const checkOut = moment(
      reservations[0].hotelDetails.checkOut,
      'DD-MM-YYYY'
    );
    const checkIn = moment(reservations[0].hotelDetails.checkIn, 'DD-MM-YYYY');
    const createdAt = moment(createdAt).format('DD-MM-YYYY');

    const dailyValue = (
      order.fare.total /
      Number(moment(checkOut).diff(moment(checkIn, 'DD-MM-YYYY'), 'days'))
    ).toFixed(2);

    const anticipation = moment(checkIn, 'DD-MM-YYYY').diff(
      moment(createdAt, 'DD-MM-YYYY'),
      'days'
    );

    return { dailyValue, anticipation };
  }, [reservations, order]);

  return (
    <div>
      <div className="d-flex mb-3">
        <InformationCard
          title={messages['travel.details.hotel.dailyValue']}
          value={
            <CurrencyWrapper value={dailyValue} decimalPlaces={0}>
              {({ formattedValue }) => formattedValue}
            </CurrencyWrapper>
          }
          Icon={MoneyIcon}
        />
        <InformationCard
          title={messages['travel.details.advance']}
          value={`${anticipation} ${messages['general.days']}`}
          Icon={CalenderIcon}
        />
      </div>
    </div>
  );
}
